import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { firestorePlugin } from 'vuefire'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(firestorePlugin)

Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
